import { CampaignFloatingToolBarChecklistsController } from './campaign-floating-tool-bar-checklists.controller'

function campaignFloatingToolBarChecklists () {
  return {
    restrict: 'E',
    scope: {
      selectedChecklist: '=',
      action: '=',
      campaign: '='
    },
    templateUrl: '/campaigns/directives/campaign-floating-tool-bar-checklists/campaign-floating-tool-bar-checklists.html?$$REVISION$$',
    controller: CampaignFloatingToolBarChecklistsController
  }
}

export { campaignFloatingToolBarChecklists }
